import Vue, { Component } from 'vue';
import { Nullable } from '@/scripts/models/utility-types';
import { getNavigationDistance } from './mask-controller-progress-calculator/navigation-helper';

interface ComponentData {
  element: Nullable<HTMLElement>;

  scrollWidth: number;
  clientWidth: number;
  scrollLeft: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useProgressCalculator = () => new Vue({
  data(): ComponentData {
    return {
      element: null,

      scrollWidth: 0,
      clientWidth: 0,
      scrollLeft: 0,
    };
  },

  computed: {
    scrollSpace(): number {
      return this.scrollWidth - this.clientWidth;
    },

    isScrollable(): boolean {
      return this.scrollSpace > 0;
    },

    progress(): number {
      const scrollSpace = this.scrollSpace;
      const progress = scrollSpace ? this.scrollLeft / scrollSpace : NaN;
      return progress;
    },
  },

  methods: {
    handleScroll(): void {
      if (this.element == null) return;

      this.scrollLeft = this.element.scrollLeft;
    },
    handleResize(): void {
      if (this.element == null) return;

      this.scrollWidth = this.element.scrollWidth;
      this.clientWidth = this.element.clientWidth;
    },

    unregisterEvent(): void {
      if (this.element == null) return;

      this.element.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      this.element = null;
    },
    registerEvent(component: Component): void {
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.element = ((component as any).$el as HTMLElement);
      this.element.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);
      this.handleScroll();
      this.handleResize();
    },

    moveLeft(): void {
      if (!this.element) return;

      const scrollTo = getNavigationDistance(this.element, this.scrollLeft, this.clientWidth, -1);
      this.element.scrollTo(scrollTo, 0);
    },
    moveRight(): void {
      if (!this.element) return;

      const scrollTo = getNavigationDistance(this.element, this.scrollLeft, this.clientWidth, 1);
      this.element.scrollTo(scrollTo, 0);
    },
  },
});
